import { Layout, Menu } from 'antd'
import { BugOutlined, HomeOutlined } from '@ant-design/icons'
import { CIMSModule, CIMSPage, pathify, Permission } from '@cims-online/shared'
import { useEffect, useState } from 'react'
import CIMSLink from 'components/CIMSLink'
import { useAuthContext } from 'context/AuthContext'
import { useLocation } from 'react-router-dom'
import CIMSLogo from 'components/CIMSLogo'
import { useProtectedMenuItem } from './hooks/useProtectedMenuItem'

/**
 * @see Login component for more information
 */
export const DevSideNav: React.VFC<{
  collapsed: boolean
}> = ({ collapsed }) => {
  const { user } = useAuthContext()
  const { pathname } = useLocation()
  const [openKeys, setOpenKeys] = useState<string[]>([])

  const segments = pathname.split('/')
  const module = segments[1]
  const page = segments[2]
  const pageId =
    CIMSPage.fromPath({
      module,
      page,
    })?.id ?? CIMSModule.Home.id

  useEffect(() => {
    /**
     * Stuff needed to keep one menu open at a time
     */
    return module === CIMSModule.Developer.pathname
      ? setOpenKeys([CIMSModule.Developer.id])
      : setOpenKeys([])
  }, [module])

  const home = user
    ? {
        key: CIMSModule.Home.id,
        icon: <HomeOutlined />,
        label: <CIMSLink to={pathify(CIMSModule.Home.pathname)}>Home</CIMSLink>,
      }
    : null

  return (
    <Layout.Sider
      collapsible
      collapsed={collapsed}
      collapsedWidth={0}
      trigger={null}
      width={300}
      style={{ overflowY: 'auto' }}
    >
      <CIMSLogo />
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={pageId ? [pageId] : []}
        openKeys={openKeys}
        onOpenChange={(keys) => {
          const latest = keys[keys.length - 1]
          setOpenKeys(latest ? [latest.toString()] : [])
        }}
        items={[
          home,
          useProtectedMenuItem({
            module: CIMSModule.Developer,
            pages: [
              {
                page: CIMSPage.Developers,
                permission: 'developer',
              },
              {
                page: CIMSPage.DeveloperSnapshots,
                permission: 'developer',
              },
              {
                page: CIMSPage.UserSync,
                permission: Permission.SyncUsers,
              },
              {
                page: CIMSPage.Redis,
                permission: Permission.RefreshRedisCache,
              },
              {
                page: CIMSPage.AssociateProject,
                permission: Permission.AssociateProjectWithCIMS,
              },
              {
                page: CIMSPage.Workflows,
                permission: 'developer',
              },
            ],
            icon: <BugOutlined />,
          }),
        ]}
      />
    </Layout.Sider>
  )
}
